import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import FactorsCriteriaServices from "./FactorsCriteria.services";
import Item from "antd/lib/list/Item";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFactorCriterion = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: true,
    });
    const resp = await FactorsCriteriaServices.getFactorCriterion(filters);
    const respSinFiltro = await FactorsCriteriaServices.getFactorCriterion();
    const sumaDePesos = {};

    respSinFiltro.data.data.forEach((item) => {
      const codigo = item.list_funcion[0].codigo;
      const peso = item.peso;
      const descripcion = item.list_funcion[0].nombre;

      if (sumaDePesos[codigo]) {
        sumaDePesos[codigo].peso += peso; // Acumula el peso
      } else {
        sumaDePesos[codigo] = { peso, descripcion }; // Agrega nueva función
      }
    });
    console.log()
    dispatch({
      type: actions.GET_FACTORCRITERION,
      payload: {
        factorsCriteria: resp.data.data,
        factorsCriteriaLength: resp.data.count,
        weightsPerTask: sumaDePesos

      },

    });

    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: false,
    });
  }


};

export const cleanFactorsCriteria = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: true,
    });
    
    dispatch({
      type: actions.GET_FACTORCRITERION,
      payload: {
        factorsCriteria: [],
        factorsCriteriaLength: 0,
        weightsPerTask: {}

      },

    });

    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: false,
    });
  }


};

export const getFactors = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: true,
    });
    const resp = await FactorsCriteriaServices.getFactor(filters);
    dispatch({
      type: actions.GET_FACTOR,
      payload: {
        factors: resp.data.data,
        factorsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: false,
    });
  }
};


export const getCriteria = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: true,
    });
    const resp = await FactorsCriteriaServices.getCriteria(filters);
    dispatch({
      type: actions.GET_CRITERION,
      payload: {
        criteria: resp.data.data,
        criteriaLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.CRITERION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.CRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: false,
    });
  }
}

export const getTasks = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TASK,
      payload: true,
    });
    const resp = await FactorsCriteriaServices.getTasks(filters);

    dispatch({
      type: actions.GET_TASK,
      payload: {
        tasks: resp.data.data,
        tasksLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.TASK_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TASK_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TASK,
      payload: false,
    });
  }
};

export const saveFactorCriterion =
  (data, setShowModal) => async (dispatch, getState) => {
    try {

      dispatch({
        type: actions.SAVE_LOADING_FACTORCRITERION,
        payload: true,
      });
      const resp = await FactorsCriteriaServices.saveFactorCriterion(data);
      console.log("retorno",resp.data)
      debugger
      const { factorsCriteria, factorsCriteriaLength, weightsPerTask } = getState().factorCriterion;
      const _factorsCriteria = [...factorsCriteria, resp.data[0]];
      const codigo = resp.data[0].list_funcion[0].codigo;
      const peso = resp.data[0].peso;
      const descripcion = resp.data[0].list_funcion[0].descripcion;
      
      const _weightsPerTask = { ...weightsPerTask }; 

      if (_weightsPerTask[codigo]) {
        _weightsPerTask[codigo].peso += peso; // Acumula el peso
      } else {
        _weightsPerTask[codigo] = { peso, descripcion }; // Agrega nueva función
      }

      dispatch({
        type: actions.GET_FACTORCRITERION,
        payload: {
          factorsCriteria: _factorsCriteria,
          factorsCriteriaLength: factorsCriteriaLength + 1,
          weightsPerTask: weightsPerTask

        },


      });

      dispatch({
        type: actions.FORM_FAIL,
        payload: "",

      })
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_FACTORCRITERION,
        payload: false,
      });
    }
  };

export const editFactorCriterion =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {

      dispatch({
        type: actions.LOADING_FACTORCRITERION,
        payload: true,
      });
      const resp = await FactorsCriteriaServices.editFactorCriterion(id, data);

      const { factorsCriteria, factorsCriteriaLength, weightsPerTask } = getState().factorCriterion;
      const _factorsCriteria = [...factorsCriteria];
      

      const oldPeso = _factorsCriteria[index].peso;
      const codigo = _factorsCriteria[index].list_funcion[0].codigo;

      _factorsCriteria[index] = resp.data;

      const _weightsPerTask = { ...weightsPerTask };
      const newPeso = resp.data.peso;

      if (_weightsPerTask[codigo]) {
        _weightsPerTask[codigo].peso = _weightsPerTask[codigo].peso - oldPeso + newPeso;
      } else {
        const descripcion = resp.data.list_funcion[0].descripcion;
        _weightsPerTask[codigo] = { peso: newPeso, descripcion };
      }
      dispatch({
        type: actions.GET_FACTORCRITERION,
        payload: {
          factorsCriteria: _factorsCriteria,
          factorsCriteriaLength: factorsCriteriaLength,
          weightsPerTask: _weightsPerTask,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_FACTORCRITERION,
        payload: false,
      });
    }
  };

export const deleteFactorCriterion = (id, index) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: true,
    });
    await FactorsCriteriaServices.deleteFactorCriterion(id);
    debugger
    const { factorsCriteria, factorsCriteriaLength, weightsPerTask } = getState().factorCriterion;
    const _factorsCriteria = [...factorsCriteria];
    const codigo = _factorsCriteria[index].list_funcion[0].codigo;
    const peso = _factorsCriteria[index].peso;

    _factorsCriteria.splice(index, 1);

    const _weightsPerTask = { ...weightsPerTask };

    // Actualizar el peso en weightsPerTask
    if (_weightsPerTask[codigo]) {
      _weightsPerTask[codigo].peso -= peso;
      // Si el peso acumulado llega a cero, eliminamos la entrada
      if (_weightsPerTask[codigo].peso <= 0) {
        delete _weightsPerTask[codigo];
      }
    }

    dispatch({
      type: actions.GET_FACTORCRITERION,
      payload: {
        factorsCriteria: _factorsCriteria,
        factorsCriteriaLength: factorsCriteriaLength - 1,
        weightsPerTask: _weightsPerTask,
      },
    });
    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.FACTORCRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTORCRITERION,
      payload: false,
    });
  }
};
